webpackJsonp([148084294277705],{

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _unstated = __webpack_require__(107);
	
	var _Header = __webpack_require__(76);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Container = __webpack_require__(43);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _LangSwitch = __webpack_require__(77);
	
	var _LangSwitch2 = _interopRequireDefault(_LangSwitch);
	
	var _TextContent = __webpack_require__(79);
	
	var _TextContent2 = _interopRequireDefault(_TextContent);
	
	var _DataTable = __webpack_require__(74);
	
	var _DataTable2 = _interopRequireDefault(_DataTable);
	
	var _Footer = __webpack_require__(75);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _LittleRectRow = __webpack_require__(78);
	
	var _LittleRectRow2 = _interopRequireDefault(_LittleRectRow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var location = _ref.location;
	  return _react2.default.createElement(
	    _unstated.Provider,
	    null,
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Header2.default, { title: 'Frauen in der IT-Branche 2018' }),
	      _react2.default.createElement(
	        'article',
	        null,
	        _react2.default.createElement(
	          _Container2.default,
	          null,
	          _react2.default.createElement(
	            _TextContent.FlexWrapper,
	            null,
	            _react2.default.createElement(_LangSwitch2.default, { location: location }),
	            _react2.default.createElement(
	              _TextContent2.default,
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                'Die Gleichberechtigung der Geschlechter hat die \xF6ffentliche Debatte der letzten Monate bestimmt und Veranstaltungen wie der Women\u2019s March haben ungleiche Rechte zwischen Frauen und M\xE4nnern auf der ganzen Welt deutlich gemacht. Wir von Honeypot sehen es als unsere Aufgabe an, Frauen in der IT-Branche zu unterst\xFCtzen. In Anbetracht des weltweiten Lohngef\xE4lles zwischen M\xE4nnern und Frauen haben wir uns dazu entschlossen, einen genaueren Blick auf die Gleichberechtigung der Geschlechter in der IT-Branche zu werfen und m\xF6chten mit dieser Studie die H\xFCrden und Chancen f\xFCr Frauen in IT-Berufen hervorheben.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Die Studie umfasst 41 L\xE4nder der OECD sowie der EU und enth\xE4lt vergleichbare Daten \xFCber die IT-Branche und das Lohngef\xE4lle. Die Daten umfassen folgende Bereiche:'
	              ),
	              _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Geschlechtergleichheit in der Gesamtwirtschaft:'
	                  ),
	                  ' ',
	                  'Faktoren wie der prozentuale Anteil der erwerbst\xE4tigen Frauen und das allgemeine geschlechtsspezifische Lohngef\xE4lle.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Frauen in der IT-Branche:'
	                  ),
	                  ' Prozentualer Frauenanteil im IT-Sektor.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Chancen f\xFCr Frauen in IT-Berufen:'
	                  ),
	                  ' Dies beschreibt den Unterschied zwischen dem prozentualen Anteil der erwerbst\xE4tigen Frauen und dem Frauenanteil in der IT-Branche. Zus\xE4tzlich wurde ber\xFCcksichtigt, wie viel Prozent der Absolventen von MINT-F\xE4chern weiblich sind.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Lohngef\xE4lle in der IT-Branche:'
	                  ),
	                  ' Der Unterschied zwischen dem Lohngef\xE4lles zwischen M\xE4nnern und Frauen in der IT-Branche und dem allgemeinen Lohngef\xE4lle.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Karrierechancen f\xFCr Frauen:'
	                  ),
	                  ' Der Frauenanteil in F\xFChrungspositionen und auf Ministerposten.'
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Schlussendlich haben wir den Geschlechterungleichheits-Index unter die Lupe genommen, um potentielle Faktoren zu identifizieren, die H\xFCrden f\xFCr Frauen darstellen und um die vielversprechendsten Chancen f\xFCr Frauen hervorzuheben. Der Index untersucht die reproduktive Gesundheit von Frauen sowie ihre wirtschaftliche Emanzipation sowie Teilnahme am Arbeitsmarkt und erm\xF6glicht Schlussfolgerungen \xFCber die Gleichberechtigung allgemein. Um zu ermitteln, ob die Gleichstellung von M\xE4nnern und Frauen in den vergangenen Jahren besser oder schlechter geworden ist, haben wir die derzeit verf\xFCgbaren Lohnl\xFCcken-Daten mit den Daten, die es vor f\xFCnf Jahren gab, miteinander verglichen.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                '\xA0\xA0\xA0\xA0\u201EDas geschlechtsspezifische Lohngef\xE4lle in der IT-Branche betr\xE4gt in Deutschland 25 %. Dies stellt den schlechtesten Wert in Westeuropa dar und ist doppelt so hoch wie in Belgien und Frankreich, wo die Lohnl\xFCcke zwischen M\xE4nnern und Frauen 11,8 % betr\xE4gt. Dies deutet darauf hin, dass der IT-Sektor in Deutschland in Sachen Gleichberechtigung hinter anderen westlichen L\xE4ndern zur\xFCckliegt\u201D, sagt Emma Tracey, Co-Founder von Honeypot. \u201EZwar unternimmt die deutsche Regierung Schritte, die sich positiv auf die Gleichberechtigung in der Wirtschaft auswirken sollen, wie das Lohntransparenzgesetz, das im Juli 2017 in Kraft getreten ist, jedoch bleibt abzuwarten, ob dieses tats\xE4chlich Wirkung zeigt oder lediglich zu mehr B\xFCrokratie f\xFChrt.\u201C'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Die folgende Tabelle zeigt eine Rangliste der L\xE4nder, in denen die Chancen f\xFCr Frauen in der IT-Branche am h\xF6chsten sind. Verglichen werden hierbei das allgemeine Lohngef\xE4lle und das Lohngef\xE4lle in der IT-Branche. Eine positive Zahl bedeutet, dass das Lohngef\xE4lle in der IT-Branche unter dem allgemeinen Lohngef\xE4lle des entsprechenden Landes liegt und Frauen in IT-Berufen fairer bezahlt werden.'
	              )
	            )
	          ),
	          _react2.default.createElement(_LittleRectRow2.default, { style: { paddingTop: 20 } })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { marginTop: 30 } },
	          _react2.default.createElement(_DataTable2.default, { currency: '\u20AC' })
	        ),
	        _react2.default.createElement(
	          _Container2.default,
	          null,
	          _react2.default.createElement(_LittleRectRow2.default, { style: { paddingBottom: 20 } }),
	          _react2.default.createElement(
	            _TextContent.FlexWrapper,
	            null,
	            _react2.default.createElement(_LangSwitch.Placeholder, null),
	            _react2.default.createElement(
	              _TextContent2.default,
	              null,
	              _react2.default.createElement(
	                'h2',
	                null,
	                'Methodik'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                'Die Studie umfasst 41 L\xE4nder der OECD und der EU, da die Methoden zur Erhebung von Daten \xFCber die IT-Branche und das geschlechtsspezifische Lohngef\xE4lle in diesen L\xE4ndern vergleichbar sind.'
	              ),
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Kriterien'
	              ),
	              _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Erwerbst\xE4tige insgesamt (in Millionen):'
	                  ),
	                  ' ',
	                  'J\xE4hrliche Arbeitskr\xE4fteerhebung, in Millionen Personen. Quelle: Statistiken der OECD, Eurostat.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Erwerbst\xE4tige Frauen (in Millionen):'
	                  ),
	                  ' ',
	                  'J\xE4hrliche Arbeitskr\xE4fteerhebung, in Millionen Personen. Quelle: Statistiken der OECD, Eurostat.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Frauenanteil (in %):'
	                  ),
	                  ' Prozentualer Anteil der erwerbst\xE4tigen Frauen.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Frauen in hochrangigen Beamtenstellen, gesetzgebenden und gesch\xE4ftsf\xFChrenden Positionen (in %):'
	                  ),
	                  ' ',
	                  'Der prozentuale Frauenanteil in F\xFChrungspositionen; ein h\xF6herer Wert bedeutet gr\xF6\xDFere Gleichstellung in Bezug auf Karrierechancen. Daten stammen vom Bericht des Weltwirtschaftsforums: Frauen und M\xE4nner in hochrangigen Beamtenstellen, gesetzgebenden und gesch\xE4ftsf\xFChrenden Positionen (%): Berufshauptgruppe 1 der Internationalen Standardklassifikation der Berufe (ISCO-08). Quellen: ILO, ILOSTAT Datenbank, Besch\xE4ftigung nach Beruf, 2016 oder die aktuellsten Daten, die verf\xFCgbar waren.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Frauen im Parlament (in %):'
	                  ),
	                  ' Report des Weltwirtschaftsforums: Prozentualer Frauenanteil im Parlament, bzw. im Unterhaus. Die Daten stammen von der Interparlamentarischen Union, \u201EWomen in National Parliaments\u201D. Die Daten beziehen sich auf Informationen, die am 1. September 2016 von den Parlamenten der verschiedenen L\xE4nder bereitgestellt wurden.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Frauen in Minister\xE4mtern (in %):'
	                  ),
	                  ' Report des Weltwirtschaftsforums: Prozentualer Frauentanteil in Minister\xE4mtern, wie Premierminister in oder Finanzministerin. In einigen F\xE4llen k\xF6nnen \xDCberschneidungen vorkommen, falls ein Ministeramt vom Staatsoberhaupt besetzt wird. Quelle: Interparlamentarische Union, \u201EWomen in Politics 2015\u201D, ber\xFCcksichtigt wurden Benennungen bis zum 1. Januar 2015. Die Daten werden alle zwei Jahre aktualisiert.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Durchschnittsgehalt (in \u20AC), Durchschnittsgehalt von Frauen (in \u20AC), geschlechtsspezifisches Lohngef\xE4lle (in \u20AC):'
	                  ),
	                  ' ',
	                  'Das Durchschnittsgehalt von M\xE4nnern und Frauen f\xFCr alle Berufe und der prozentuale Unterschied zwischen beiden Geschlechtern wird als geschlechtsspezifisches Lohngef\xE4lle bezeichnet. Daf\xFCr wurden die aktuellsten, verf\xFCgbaren Daten genutzt (2015). Quellen: OECD, Eurostat. Der Durchschnitt beider Quellen. Eurostat: Der Unterschied zwischen den durchschnittlichen Bruttostundenl\xF6hnen von M\xE4nnern und Frauen, dargestellt als prozentuale Abweichung vom durchschnittlichen Bruttostundenlohn von M\xE4nnern. OECD: Unterschied zwischen den Medianeinkommen von M\xE4nnern und Frauen, dargestellt relativ zum Medianeinkommen von M\xE4nnern. Daten beziehen sich auf Vollzeitbesch\xE4ftigte und selbstst\xE4ndige Erwerbst\xE4tige.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Erwerbst\xE4tige in der IT-Branche (in Tausend):'
	                  ),
	                  ' ',
	                  'Personen in Berufen der Informations- und Kommunikationstechnik in Tausend. Berufsuntergruppe 25 der Internationalen Standardklassifikation der Berufe (ISCO-08). Akademische und vergleichbare Fachkr\xE4fte in der Informations- und Kommunikationstechnologie. Der Informations- und Kommunikationssektor wurde per Definition ins Leben gerufen, indem Aktivit\xE4ten zur Produktion und Distribution von Informationen und kulturellen Produkten, die Bereitstellung von Mitteln zur \xDCbertragung und Verteilung von solchen Produkten sowie von Daten und Nachrichten, IT-Aktivit\xE4ten, Datenverarbeitung und andere Informationsdienstleistungen miteinander kombiniert wurden. Die Hauptbestandteile dieses Abschnitts sind verlegerische T\xE4tigkeiten, wie das Ver\xF6ffentlichen von Software (division 58), das Aufzeichnen von Film und Ton (division 59), die Planung und Ausstrahlung von Radio und Fernsehen (division 59), Aktivit\xE4ten der Telekommunikation (division 61), informationstechnologische Aktivit\xE4ten (division 62) und andere Informationsdienstleistungen (division 63). Quelle: Eurostat.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Erwerbst\xE4tige in der IT-Branche (in %):'
	                  ),
	                  ' Der prozentuale Anteil der Erwerbst\xE4tigen (aller Geschlechter), die in der IT-Branche t\xE4tig sind.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Frauen in der IT-Branche (in Tausend):'
	                  ),
	                  ' Anzahl der Frauen in der IT-Branche.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Frauen in der IT-Branche (in %):'
	                  ),
	                  ' Der prozentuale Frauenanteil aller Erwerbst\xE4tigen im IT-Sektor.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Frauenanteil der MINT-Absolventen (in %):'
	                  ),
	                  ' ',
	                  'Prozentualer Frauenanteil der MINT-F\xE4cher-Absolventen, Daten stammen vom Bericht des Weltwirtschaftsforums. Quelle: UNESCO Institute for Statistics (aufgerufen: September 2016). Untersucht wird der prozentuale Anteil von Frauen und M\xE4nnern unter Absolventen von ISCED-5-8-Studieng\xE4ngen der Mathematik, Informatik, Naturwissenschaft und Technik (prozentualer Anteil aller Absolventen und Absolventinnen).'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Durchschnittsgehalt in der IT-Branche (in \u20AC):'
	                  ),
	                  ' ',
	                  'Durchschnittliches Jahresgehalt in der IT-Branche (wie oben definiert). Jahresgehalt in EUR KKP (Kaufkraftparit\xE4t), bereinigt nach Lohnniveau (KKP) der OECD und Lohnniveau (KKP) der EU. Quellen: OECD, Eurostat, \xF6rtliche Berichte.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Durchschnittliches Gehalt f\xFCr Frauen in der IT-Branche (in \u20AC):'
	                  ),
	                  ' ',
	                  'Durchschnittliches Gehalt f\xFCr Frauen in der IT-Branche (wie oben definiert), in EUR KKP (Kaufkraftparit\xE4t), unter Ber\xFCcksichtigung des Lohngef\xE4lles in der IT-Branche und des durchschnittlichen Gehalts in der IT-Branche. Quellen: OECD, Eurostat, \xF6rtliche Berichte.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Geschlechtsspezifisches Lohngef\xE4lle in der IT-Branche (in %):'
	                  ),
	                  ' ',
	                  'Lohngef\xE4lle im IT-Sektor (wie oben definiert). Quellen: Eurostat, OECD, \xF6rtliche Berichte.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Differenz zwischen dem allgemeinen geschlechtsspezifischen Lohngef\xE4lle und dem geschlechtsspezifischen Lohngef\xE4lle im IT-Sektor (in %):'
	                  ),
	                  ' ',
	                  'Der Prozentuale Unterschied zwischen dem geschlechtsspezifischen Lohngef\xE4lle im IT-Sektor und dem allgemeinen geschlechtsspezifischen Lohngef\xE4lle. Ein positiver Wert bedeutet, dass Frauen im IT-Sektor im Vergleich zu anderen Berufen fairer bezahlt werden.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Geschlechterungleichheits-Index:'
	                  ),
	                  ' Die Punktzahl 0 steht f\xFCr Gleichberechtigung der Geschlechter. Je h\xF6her der Wert, desto ausgepr\xE4gter die Ungleichheit. Je n\xE4her die Punktzahl am Wert 0 liegt, desto geringer ist die Ungleichheit in einem Land. Gender Inequality Index (2015). Quelle: Human Development Report.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Geschlechtsspezifisches Lohngef\xE4lle 2010:'
	                  ),
	                  ' ',
	                  'Geschlechtsspezifisches Lohngef\xE4lle (wie oben definiert), Daten von 2010 (Daten \xFCber das aktuelle Lohngef\xE4lle sind von 2015). Im Fall von Chile von 2011, da keine Daten f\xFCr 2010 verf\xFCgbar waren.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Vergleich der geschlechtsspezifischen Lohngef\xE4lle von 2010 und 2015:'
	                  ),
	                  ' ',
	                  'Differenz zwischen dem aktuellen Lohngef\xE4lle der Studie und der Lohnl\xFCcke f\xFCnf Jahre fr\xFCher. Ein positiver Wert steht f\xFCr einen positiven Anstieg, d. h. das geschlechtsspezifische Lohngef\xE4lle hat sich vergr\xF6\xDFert. Ein negativer Wert bedeutet, dass sich die Lohnunterschiede verringert haben.'
	                ),
	                _react2.default.createElement(
	                  'li',
	                  null,
	                  _react2.default.createElement(
	                    'em',
	                    null,
	                    'Wechselkurs vom 26.02.2018. 1 USD = 0,81 Euro = 0,71 GBP'
	                  )
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(_Footer2.default, null)
	    )
	  );
	};
	
	// Local
	

	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-de-js-c913de650937adf431b1.js